import { FieldType } from "../api.js";
import { BaseModelConvertSpec } from "./base.specs.js";
const WalletModelConvertSpec = {
  ...BaseModelConvertSpec,
  balance: FieldType.BigNumber
};
const RewardsStatusSpecs = {
  balance: FieldType.Number,
  lastClaimedAt: FieldType.DateTime,
  currentPeriodResetDate: FieldType.DateTime,
  nextPeriodResetDate: FieldType.DateTime
};
export {
  RewardsStatusSpecs,
  WalletModelConvertSpec
};
